import Cookies from 'js-cookie';
import React, { useContext, useEffect } from 'react';
import { GlobalContext } from '../context/GlobalContext';

const Profile = () => {
  const user = JSON.parse(Cookies.get('user'));

  return (
    <div className="col-10 d-flex flex-column justify-content-center">
      <div className="d-flex flex-column align-items-center justify-content-center">
        <h1>Profil</h1>
        <img
          src={user.image_url}
          className="p-2 profile-img mx-auto align-self-center"
        />
      </div>
      <h3 className="p-2 text-center">
        Nama: <span>{user.name}</span>
      </h3>
      <h3 className="p-2 text-center">
        Email: <span>{user.email}</span>
      </h3>
    </div>
  );
};

export default Profile;
